import { motion } from "framer-motion";
import { Reveal, Label } from "./Motion";
import { CATEGORIES } from "../data";

export const Collection = ({ scrollTo }) => (
  <section id="collection" data-testid="collection" className="relative py-24 md:py-36 bg-[#F7F5F0]">
    <div className="mx-auto max-w-[1400px] px-6 md:px-10">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
        <div>
          <Reveal><Label>The Collection</Label></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-5 font-serif text-4xl sm:text-5xl lg:text-6xl text-[#2c2826] leading-[1.02]">
              Objects with<br /><span className="italic">a story.</span>
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.1}>
          <p className="max-w-sm text-[#5a5451] leading-relaxed">
            A tightly edited range of cushion covers, candles, vases and beaded
            coasters — each chosen for texture, tone and the way it changes a room.
          </p>
        </Reveal>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
        {CATEGORIES.map((c, i) => (
          <Reveal key={c.id} delay={(i % 4) * 0.08}>
            <motion.button
              data-testid={`product-${c.id}`}
              onClick={() => scrollTo("enquire")}
              whileHover="hover"
              className={`group relative block w-full text-left overflow-hidden pc-grain ${i % 2 === 1 ? "lg:-translate-y-8" : ""}`}
            >
              <div className="relative aspect-[3/4] overflow-hidden bg-[#EAE5DC]">
                <div className="absolute inset-0 pc-spotlight z-10 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <motion.img
                  src={c.img} alt={c.name}
                  variants={{ hover: { scale: 1.06 } }}
                  transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
                  className="h-full w-full object-cover"
                />
                <div className="absolute top-4 left-4 z-20">
                  <span className="rounded-full bg-[#F7F5F0]/85 backdrop-blur px-3 py-1 text-[11px] uppercase tracking-[0.2em] text-[#5a5451]">
                    {c.tag}
                  </span>
                </div>
              </div>
              <div className="pt-5 pb-2 flex items-start justify-between gap-4">
                <div>
                  <h3 className="font-serif text-2xl md:text-3xl text-[#2c2826]">{c.name}</h3>
                  <p className="mt-2 text-sm text-[#5a5451] max-w-xs leading-relaxed">{c.desc}</p>
                </div>
                <span className="mt-2 text-[#985F47] text-sm whitespace-nowrap opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-[opacity,transform] duration-400">
                  Enquire &rarr;
                </span>
              </div>
            </motion.button>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
